// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\Vision\\AppData\\Roaming\\nvm\\v16.13.1\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Ubuntu);"]);
// Module
exports.push([module.id, "/*\r\n *   Copyright (c) 2021 vlinder Labs Private Limited\r\n *   All rights reserved.\r\n *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.\r\n */", ""]);
// Exports
module.exports = exports;
